import { currentFlowState, replaceFlowContentState } from '@/state';
import { liveGuideFlowState } from '@/state/guide.state';
import { useUnwrappedAtomValue } from '@/state/loadableHooks';
import logger from '@/util/logger';
import type { AppFlowParams } from '@rock/types';
import { useSetAtom } from 'jotai';
import { useState } from 'react';
import { toast } from 'sonner';

const log = logger('usePullGuide');

export function usePullGuide(params: AppFlowParams) {
    const [pulling, setPulling] = useState(false);
    const currentFlow = useUnwrappedAtomValue(currentFlowState(params));
    const replaceFlowContent = useSetAtom(replaceFlowContentState(params));
    const liveGuideFlow = useUnwrappedAtomValue(liveGuideFlowState(params));

    async function pullGuide() {
        if (currentFlow && liveGuideFlow) {
            setPulling(true);
            try {
                await replaceFlowContent({
                    nodes: liveGuideFlow.nodes,
                    edges: liveGuideFlow.edges,
                    nextId: liveGuideFlow.nextId,
                });
                toast.success('Pulled Guide Successfully');
                log.info(`Pulled Guide Successfully, space: ${currentFlow.space}, flow id: ${currentFlow.id}`);
            } catch (err) {
                toast.error('Error Pulling Guide', {
                    description: 'An unexpected error occurred.',
                });
                log.error('Error pulling guide', { err });
            } finally {
                setPulling(false);
            }
        }
    }

    return [pulling, pullGuide] as const;
}
